import { render, staticRenderFns } from "./search-bar.component.html?vue&type=template&id=5abb41ac&"
import script from "./search-bar.component.ts?vue&type=script&lang=ts&"
export * from "./search-bar.component.ts?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports